import { createLogger } from "./logger";
const logger = createLogger();

export const checkEnvironmentVariable = (variable: string) => {
  if (!process.env[variable]) {
    logger.error(`${variable} is not set in the environment variables`);
    throw new Error(`${variable} is not set in the environment variables`);
  }

  return process.env[variable];
};
